<div *ngIf="associatedProjectId && associatedLocationId; else noLocationAssociatedMessage">
    <form *ngIf="vSensorService.projectLocations
                && vSensorService.projectLocations.length > 0
                && !formChangesInProcess"
          [formGroup]="deviceParams">
        <mat-form-field>
            <input matInput
                   formControlName="const"
                   [placeholder]="'const' | translate">
            <mat-error *ngIf="deviceParams.get('const').hasError('required')">
                {{'REQUIRED' | translate}}
            </mat-error>
            <mat-error *ngIf="deviceParams.get('const').hasError('not a number')">
                {{'NUMBER_REQUIRED' | translate}}
            </mat-error>
        </mat-form-field>

        <div *ngFor="let control of deviceParamsLocationControls; let i = index;">
            <app-v-sensor-location-param
                    [paramGroup]="control"
                    [readOnly]="readOnly"
                    (deleteLocation)="deleteLocationControl(i)">
            </app-v-sensor-location-param>
        </div>
        <button *ngIf="!readOnly"
                (click)="addLocationControl()">
            <fa-icon [icon]="faPlusCircle"></fa-icon>
            {{'NEW_ELEMENT' | translate}}
        </button>

    </form>
    <div *ngIf="vSensorService.projectLocations && vSensorService.projectLocations.length === 0">
        <div class="warning-container error">
            <fa-icon [icon]="faInfoCircle"></fa-icon>
            {{'NO_LOCATION_AVAILABLE' | translate}}
        </div>
    </div>
</div>

<ng-template #noLocationAssociatedMessage>
    <div *ngIf="!readOnly" class="warning-container updateMode">
        <fa-icon [icon]="faInfoCircle"></fa-icon>
        <div class="message">
            {{'PARAM_NOT_AVAILABLE_EXPL_0' | translate}}
            <ul>
                <li><span>1.</span> {{'PARAM_NOT_AVAILABLE_EXPL_1' | translate}}</li>
                <li><span>2.</span> {{'PARAM_NOT_AVAILABLE_EXPL_2' | translate}}</li>
            </ul>
        </div>
    </div>
    <div *ngIf="readOnly" class="warning-container">
        <fa-icon [icon]="faInfoCircle"></fa-icon>
        {{'PARAMETER_EDITION_NOT_AVAILABLE' | translate}}
    </div>
</ng-template>
